import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

interface Tutorial {
  title: string;
  description: string;
  loomId: string;
}

const tutorials: Tutorial[] = [
  {
    title: 'Events ergänzen & bearbeiten (Teil 1)',
    description: 'Lerne, wie du fehlende Informationen zu Events ergänzen oder neue Events vorschlagen kannst.',
    loomId: '55f6adb37a524459ac08453a35563966',
  },
  {
    title: 'Events ergänzen & bearbeiten (Teil 2)',
    description: 'Weitere Tipps und Funktionen zum Bearbeiten und Vorschlagen von Events.',
    loomId: '51f8dcc317864feabaa5e64748c1f4b3',
  },
];

const Tutorials: React.FC = () => {
  usePageTitle('Tutorials');
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)' }}>
      <div style={{
        background: 'var(--surface-bg)',
        borderBottom: '1px solid var(--surface-border)',
        padding: '12px 16px',
        paddingTop: 'max(12px, env(safe-area-inset-top))',
        display: 'flex', alignItems: 'center', gap: 12,
      }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: 'var(--text-primary)' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
            style={{ width: 22, height: 22 }}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>
        <h1 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-primary)' }}>Tutorials</h1>
      </div>

      <div style={{ padding: 16, maxWidth: 640, margin: '0 auto' }}>
        <p style={{ fontSize: 14, color: 'var(--text-muted)', marginBottom: 16 }}>
          Kurze Video-Anleitungen, die dir den Einstieg erleichtern.
        </p>

        {tutorials.map((t, i) => (
          <div key={i} className="surface-card" style={{ borderRadius: 16, marginBottom: 16, overflow: 'hidden' }}>
            <div style={{ position: 'relative', paddingBottom: '62.5%', height: 0 }}>
              <iframe
                src={`https://www.loom.com/embed/${t.loomId}`}
                frameBorder="0"
                allowFullScreen
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                title={t.title}
              />
            </div>
            <div style={{ padding: '14px 20px' }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' }}>
                {t.title}
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
                {t.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tutorials;
